export default __webpack_public_path__ + "static/experiment-goal-warning-dark-mode-1443d2488efa972788d6e00bfba920b2.png";